import { Link } from "react-router-dom";
import { Phone, MessageSquare, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-900/90 backdrop-blur-lg border-t border-blue-500/20 mt-12 md:mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="block mb-4">
              <div className="flex items-center space-x-2">
                <img
                  src="/images/logo.png"
                  alt="White Pearl Finance Logo"
                  className="h-10 w-auto"
                />
                <span className="text-white text-2xl font-bold"></span>
              </div>
            </Link>
            <p className="text-gray-300 text-sm sm:text-base mb-4 leading-relaxed">
              Your trusted partner for all financial needs. Quick loans, best rates, instant approvals at White Pearl Finance.
            </p>
            <div className="space-y-2 text-sm text-gray-400">
              <p className="leading-relaxed">
                Your trusted partner for all financial needs. Quick loans, best rates, instant approvals.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="mt-8 lg:mt-0">
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/calculators" className="block text-gray-300 hover:text-blue-400 transition-colors">
                Calculators
              </Link>

              <Link to="/terms-and-conditions" className="block text-gray-300 hover:text-blue-400 transition-colors mt-2">
                Terms & Conditions
              </Link>
              <Link to="/privacy-policy" className="block text-gray-300 hover:text-blue-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="block text-gray-300 hover:text-blue-400 transition-colors">
                Apply Now
              </Link>
            </div>
          </div>

          {/* Loan Products */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Services</h4>
            <div className="space-y-2 text-gray-300">
              <div>Home Loan</div>
              <div>Business Loan</div>
              <div>Mortage Loan</div>
              <div>Project Loan</div>
              <div>Mortage Loan</div>
              <div>Personal Loan</div>
              <div>Education Loan</div>
              <div>New Car Loan</div>
              <div>Used Car Loan</div>
            </div>
          </div>

          {/* Address */}
          <div className="mt-8 lg:mt-0">
            <h4 className="text-lg font-semibold text-white mb-4">Address</h4>
            <div className="text-gray-300 space-y-2">
              <div>10, Ganjawala Apt,</div>
              <div>Building No. 3,</div>
              <div>Borivali (W),</div>
              <div>Mumbai - 400092, INDIA.</div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="mt-8 lg:mt-0">
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a
                href="tel:+919324471736"
                className="flex items-center text-gray-300 hover:text-blue-400 transition-colors"
              >
                <Phone className="h-4 w-4 mr-2" />
                +91 93244 71736
              </a>
              <a
                href="https://wa.me/919324471736"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-300 hover:text-green-400 transition-colors"
              >
                <MessageSquare className="h-4 w-4 mr-2" />
                WhatsApp Support
              </a>
              <a
                href="mailto:info@whitepearlfinance.com"
                className="flex items-center text-gray-300 hover:text-blue-400 transition-colors"
              >
                <Mail className="h-4 w-4 mr-2" />
                info@whitepearlfinance.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-4 md:mt-4 pt-4 md:pt-4 px-4 text-center text-gray-400 text-xs sm:text-sm">
          <p>&copy; {new Date().getFullYear()} White Pearl Finance. All rights reserved.</p>
          <p className="text-sm mt-2">
            *Terms and conditions apply. Interest rates subject to change.
          </p>
        </div>
      </div>
    </footer>
  );
};
